import { writable } from "svelte/store";
import type { Distributor, DistributorCredential } from "@shared/types/DistributorCredential";

export interface CredentialManagementStore {
  credentials: DistributorCredential[];
  distributors: Distributor[];
  loaded: boolean;
  failed: boolean;
  pagination: {
    page: number;
    perPage: number;
    totalEntries: number;
  };
  filters: {
    order: string;
    direction: string;
    search: string;
  };
}

export const resetCredentialManagementStore = () =>
  CredentialManagementStore.set(defaultCredentialStore);

export const resetCredentials = () => {
  CredentialManagementStore.update(state => ({
    ...state,
    credentials: [],
    distributors: [],
  }));
};

const paginationInitialState = {
  page: 1,
  perPage: 10,
  totalEntries: 0,
};

const defaultCredentialStore = {
  credentials: [],
  distributors: [],
  loaded: false,
  failed: false,
  pagination: paginationInitialState,
  filters: {
    order: "distributors.name",
    direction: "ASC",
    search: "",
  },
};

export const CredentialManagementStore =
  writable<CredentialManagementStore>(defaultCredentialStore);
